import type { DrawdownPayment } from '@/types/drawdown';

/** A payment row, and enough of its investor to say what it settled. */
export type PendingUnlink = {
  payment: DrawdownPayment;
  investorName: string;
};

/** A payment carrying a staged line was settled from the provider feed. */
export function settledFromTheFeed(payment: DrawdownPayment): boolean {
  return payment.bank_incoming_id != null;
}
